// src/app/util/listas.ts
// Listas centralizadas por entidad, accesibles como:
//   import { empresas, candidatos, vacantes } from '../util/listas';
//   empresas.listCamposObligatorios

import parameters from "./parameters";

export const empresasCargue = {
	Headers: [
		"Tipo de documento",
		"Número de documento",
		"Razón social",
		"Naturaleza",
		"Tipo",
		"Tamaño por número de empleados",
		"Código CIIU",
		"Sector económico",
		"Gremio Principal",
		"Gremio secundario",
		"Implementa acciones y/o hace parte de programas corporativos",
		"Interés de la Empresa",
		"Descripción de la compañía",
		"Nombre de la sede",
		"Pertenece a zona",
		"Vía principal (Dirección sede)",
		"Número 1 (Dirección sede)",
		"Letra 1 (Dirección sede)",
		"BIS 1 (Dirección sede)",
		"Letra 2 (Dirección sede)",
		"Cardinalidad 1 (Dirección sede)",
		"Número 2 (Dirección sede)",
		"Letra 3 (Dirección sede)",
		"Número 3 (Dirección sede)",
		"Cardinalidad 2 (Dirección sede)",
		"Tipo de complemento (Dirección sede)",
		"Complemento (Dirección sede)",
		"Dirección sede",
		"Correo electrónico (Información de contacto)",
		"Vía principal (Dirección notificación)",
		"Número 1 (Dirección notificación)",
		"Letra 1 (Dirección notificación)",
		"BIS 1 (Dirección notificación)",
		"Letra 2 (Dirección notificación)",
		"Cardinalidad 1 (Dirección notificación)",
		"Número 2 (Dirección notificación)",
		"Letra 3 (Dirección notificación)",
		"Número 3 (Dirección notificación)",
		"Cardinalidad 2 (Dirección notificación)",
		"Tipo de complemento (Dirección notificación)",
		"Complemento (Dirección notificación)",
		"Dirección notificación",
		"Teléfono (Información de contacto)",
		"Extensión del teléfono (Información de contacto)",
		"País (Información de contacto)",
		"Departamento (Información de contacto)",
		"Municipio (Información de contacto)",
		"Localidad (Información de contacto)",
		"Prestador principal (Información de contacto)",
		"Punto de atención (Información de contacto)",
		"Primer nombre (Datos admin de la cuenta plataforma)",
		"Segundo nombre (Datos admin de la cuenta plataforma)",
		"Primer apellido (Datos admin de la cuenta plataforma)",
		"Segundo apellido (Datos admin de la cuenta plataforma)",
		// "Tipo de documento (Datos admin de la cuenta plataforma)",
		"Número de documento (Datos admin de la cuenta plataforma)",
		"Teléfono (Datos admin de la cuenta plataforma)",
		"Cargo (Datos admin de la cuenta plataforma)",
		//"Correo electrónico (Datos admin de la cuenta plataforma)",
		"Primer nombre (Información del representante legal)",
		"Segundo nombre (Información del representante legal)",
		"Primer apellido (Información del representante legal)",
		"Segundo apellido (Información del representante legal)",
		"Tipo de documento (Información del representante legal)",
		"Número de documento (Información del representante legal)",
		"Teléfono (Información del representante legal)",
		"Cargo (Información del representante legal)",
		"Correo electrónico (Información del representante legal)",
	],
	CamposObligatorios: [
		"Tipo de documento", "Número de documento", "Razón social", "Naturaleza",
		"Tamaño por número de empleados",
		"Código CIIU", "Sector económico",
		"Gremio Principal",
		"Implementa acciones y/o hace parte de programas corporativos",
		"Interés de la Empresa", "Descripción de la compañía", "Nombre de la sede",
		"Pertenece a zona", "Vía principal (Dirección sede)", "Número 1 (Dirección sede)",
		"Número 3 (Dirección sede)", "Complemento (Dirección sede)", "Dirección sede",
		"Complemento (Dirección sede)",
		"Dirección sede",
		"Correo electrónico (Información de contacto)",
		"Vía principal (Dirección notificación)",
		"Número 1 (Dirección notificación)",
		"Letra 1 (Dirección notificación)",
		"País (Información de contacto)",
		"Departamento (Información de contacto)",
		"Municipio (Información de contacto)",
		//"Localidad (Información de contacto)",
		"Primer nombre (Datos admin de la cuenta plataforma)",
		"Primer apellido (Datos admin de la cuenta plataforma)",		
		"Tipo de documento (Datos admin de la cuenta plataforma)",
		"Número de documento (Datos admin de la cuenta plataforma)",
		"Teléfono (Datos admin de la cuenta plataforma)",
		"Cargo (Datos admin de la cuenta plataforma)",
		"Correo electrónico (Datos admin de la cuenta plataforma",
		"Primer nombre (Información del representante legal)",
		"Primer apellido (Información del representante legal)",
		"Tipo de documento (Información del representante legal)",
		"Número de documento (Información del representante legal)",
		"Cargo (Información del representante legal)",
		"Correo electrónico (Información del representante legal)",
	],
    LimitesCaracteres: [
		{ campo: "Número de documento", min: 9, max: 9 },
		{ campo: "Razón social", max: 250 },
		{ campo: "Descripción de la compañía", min: 100, max: 1200  },
        { campo: "Nombre de la sede", max: 250 },
		{ campo: "Extensión del teléfono (Información de contacto)", max: 5 },        
		{ campo: "Primer nombre (Datos admin de la cuenta plataforma)", min: 2, max: 40 },
		{ campo: "Segundo nombre (Datos admin de la cuenta plataforma)", min: 2, max: 40 },
		{ campo: "Primer apellido (Datos admin de la cuenta plataforma)", min: 2, max: 40 },
		{ campo: "Segundo apellido (Datos admin de la cuenta plataforma)", min: 2, max: 40 },
        { campo: "Teléfono (Datos admin de la cuenta plataforma)", min: 7, max: 10 },
        { campo: "Primer nombre (Información del representante legal)", min: 2, max: 40 },
        { campo: "Segundo nombre (Información del representante legal)", min: 2, max: 40 },
        { campo: "Primer apellido (Información del representante legal)", min: 2, max: 40 },
        { campo: "Segundo apellido (Información del representante legal)", min: 2, max: 40 },
        { campo: "Teléfono (Información del representante legal)", min: 7, max: 10 }
	],
	CamposUnicos: [
		{ campo1: "Tipo de documento", campo2: "Número de documento"},
		{ campo1: "Razón social", campo2: ""},
		{ campo1: "Tipo de documento (Datos admin de la cuenta plataforma)", campo2: "Número de documento (Datos admin de la cuenta plataforma)"},
		{ campo1: "Correo electrónico (Datos admin de la cuenta plataforma", campo2: ""}
	],
    camposEnParametros: [
        { campo: "Tipo de documento", tipo: parameters.TIPODOCUMENTOEMPRESA, campoParam: "value"},
        { campo: "Naturaleza", tipo: parameters.NATURALEZAEMPRESA, campoParam: "value"},
        { campo: "Tipo", tipo: parameters.TIPOEMPRESA, campoParam: "value"},
        { campo: "Tamaño por número de empleados", tipo: parameters.TAMANOEMPRESA, campoParam: "value"},
        { campo: "Interés de la Empresa", tipo: parameters.INTERESESEMPRESA, campoParam: "value"},
        { campo: "Pertenece a zona", tipo: parameters.ZONA, campoParam: "value"},
        { campo: "Vía principal (Dirección sede)", tipo: parameters.VIAPRINCIPALEMPRESA, campoParam: "value"},
        { campo: "Letra 1 (Dirección sede)", tipo: parameters.VIAPRINCIPALPRIMERALETRA, campoParam: "value"},
        { campo: "BIS 1 (Dirección sede)", tipo: parameters.VIAPRINCIPALBIS, campoParam: "value"},
        { campo: "Letra 2 (Dirección sede)", tipo: parameters.VIAPRINCIPALPRIMERALETRA, campoParam: "value"},
        { campo: "Cardinalidad 1 (Dirección sede)", tipo: parameters.VIAPRINCIPALCUADRANTE, campoParam: "value"},
        { campo: "Letra 3 (Dirección sede)", tipo: parameters.VIAPRINCIPALPRIMERALETRA, campoParam: "value"},
        { campo: "Cardinalidad 2 (Dirección sede)", tipo: parameters.VIAPRINCIPALCUADRANTE, campoParam: "value"},
        { campo: "Tipo de complemento (Dirección sede)", tipo: parameters.VIAPRINCIPALDIRECCION, campoParam: "value"},
        { campo: "Vía principal (Dirección notificación)", tipo: parameters.VIAPRINCIPALEMPRESA, campoParam: "value"},
        { campo: "Letra 1 (Dirección notificación)", tipo: parameters.VIAPRINCIPALPRIMERALETRA, campoParam: "value"},
        { campo: "BIS 1 (Dirección notificación)", tipo: parameters.VIAPRINCIPALBIS, campoParam: "value"},
        { campo: "Letra 2 (Dirección notificación)", tipo: parameters.VIAPRINCIPALPRIMERALETRA, campoParam: "value"},
        { campo: "Cardinalidad 1 (Dirección notificación)", tipo: parameters.VIAPRINCIPALCUADRANTE, campoParam: "value"},
        { campo: "Letra 3 (Dirección notificación)", tipo: parameters.VIAPRINCIPALPRIMERALETRA, campoParam: "value"},
        { campo: "Cardinalidad 2 (Dirección notificación)", tipo: parameters.VIAPRINCIPALCUADRANTE, campoParam: "value"},
		{ campo: "Tipo de complemento (Dirección notificación)", tipo: parameters.VIAPRINCIPALDIRECCION, campoParam: "value"},
        { campo: "Tipo de complemento", tipo: parameters.VIAPRINCIPALDIRECCION, campoParam: "value"},
        { campo: "País (Información de contacto)", tipo: parameters.PAIS, campoParam: "value"},
        { campo: "Departamento (Información de contacto)", tipo: parameters.DEPARTAMENTO, campoParam: "value"},
        { campo: "Municipio (Información de contacto)", tipo: parameters.MUNICIPIO, campoParam: "value"},        
        { campo: "Prestador principal (Información de contacto)", tipo: parameters.PRESTADORPREFERENCIA, campoParam: "value"},
        { campo: "Punto de atención (Información de contacto)", tipo: parameters.PUNTOATENCION, campoParam: "value"},
        { campo: "Tipo de documento  (Datos admin de la cuenta plataforma)", tipo: parameters.TIPODOCUMENTO, campoParam: "value"},
        { campo: "Cargo (Datos admin de la cuenta plataforma)", tipo: parameters.CARGOADMINISTRADOR, campoParam: "value"},
        { campo: "Tipo de documento (Información del representante legal)", tipo: parameters.TIPODOCUMENTO, campoParam: "value"},
		{ campo: "Cargo (Información del representante legal)", tipo: parameters.CARGOADMINISTRADOR, campoParam: "value"},    
		{ campo: "Implementa acciones y/o hace parte de programas corporativos", tipo: parameters.PROGRAMASCORPORATIVOS, campoParam: "label"},  
		 
    ],

	fileName: 'plantilla_empresas.xlsx',
	sheetName: 'Empresas',
};

// Nombres de las ~14 columnas Sí/No de "tipo de población" (parámetro POBLACIONES, códigos 1-14),
// en el mismo orden en que aparecen en la plantilla. Se exportan aparte porque useCargueCandidatos.ts
// necesita reconstruir el valor combinado "tipo_poblacion" (códigos separados por coma) a partir de
// estas columnas — igual que hace Step1.tsx (steps/curriculum-registration) en la UI del candidato.
export const CamposTipoPoblacion: { campo: string; codigoPoblacion: string }[] = [
	{ campo: 'Persona en habitabilidad en calle', codigoPoblacion: '3' },
	{ campo: 'Persona en proceso de reincorporación, reintegración y/o desmovilización', codigoPoblacion: '6' },
	{ campo: 'Joven mayor de 18 años que está o estuvo en protección del ICBF', codigoPoblacion: '2' },
	{ campo: 'Vendedor informal en reconversión laboral', codigoPoblacion: '12' },
	{ campo: 'Joven del sistema de responsabilidad penal adolescente', codigoPoblacion: '1' },
	{ campo: 'Población postpenitenciaria – privada de la libertad al menos 3 meses', codigoPoblacion: '9' },
	{ campo: 'Reciclador de oficio en reconversión laboral', codigoPoblacion: '10' },
	{ campo: 'Persona en procesos de reintegración', codigoPoblacion: '8' },
	{ campo: 'Retornado (persona que ha vivido en el extranjero y regresó al país)', codigoPoblacion: '11' },
	{ campo: 'Persona que realiza actividades sexuales pagas', codigoPoblacion: '4' },
	{ campo: 'Persona trans', codigoPoblacion: '5' },
	{ campo: 'Víctima del conflicto armado', codigoPoblacion: '14' },
	{ campo: 'Persona víctima de trata de personas', codigoPoblacion: '7' },
	{ campo: 'Víctima de violencia basada en género (VVG)', codigoPoblacion: '13' },
];

// Columnas de dirección de residencia descompuesta (steps/curriculum-registration/Step2.tsx),
// en el orden en que se concatenan para formar "Dirección de residencia" (ver handleDirectionValue
// en Step2.tsx). Cada una mapea a un atributo id_coordenada[_0N] de UserCurriculo.
export const CamposDireccionResidencia: { campo: string; atributo: string }[] = [
	{ campo: 'Vía principal (Dirección)', atributo: 'local' },
	{ campo: 'Número 1 (Dirección)', atributo: 'id_coordenada' },
	{ campo: 'Letra 1 (Dirección)', atributo: 'id_coordenada_02' },
	{ campo: 'BIS 1 (Dirección)', atributo: 'id_coordenada_03' },
	{ campo: 'Letra 2 (Dirección)', atributo: 'id_coordenada_04' },
	{ campo: 'Cardinalidad 1 (Dirección)', atributo: 'id_coordenada_05' },
	{ campo: 'Número 2 (Dirección)', atributo: 'id_coordenada_06' },
	{ campo: 'Letra 3 (Dirección)', atributo: 'id_coordenada_07' },
	{ campo: 'Número 3 (Dirección)', atributo: 'id_coordenada_08' },
	{ campo: 'Cardinalidad 2 (Dirección)', atributo: 'id_coordenada_09' },
];

// Nombres de columna "especiales": no son catálogo plano de `parameters` (van en cascada o vienen de
// un endpoint propio), así que useCargueCandidatos.ts las valida como texto libre contra una lista
// pre-cargada en vez de generar un dropdown nativo de Excel.
export const CAMPO_MUNICIPIO_NACIMIENTO = 'Municipio de nacimiento';
export const CAMPO_DEPARTAMENTO_NACIMIENTO = 'Departamento de nacimiento';
export const CAMPO_MUNICIPIO_RESIDENCIA = 'Municipio de residencia';
export const CAMPO_DEPARTAMENTO_RESIDENCIA = 'Departamento de residencia';
export const CAMPO_LOCALIDAD = 'Localidad';
export const CAMPO_BARRIO = 'Barrio';
export const CAMPO_CARGO_DESEADO = '¿En qué le gustaría trabajar?';

// --- Steps 5-8 (Nivel educativo, Experiencia laboral, Educación informal, Idiomas y habilidades) ---
// Catálogos que NO son `parameters` sino tablas/endpoints propios (NivelEducativo, NucleoConocimiento,
// AreaDesempeno, TituloHomologado) — mismo criterio que Municipio/Barrio/Cargo arriba.
export const CAMPO_NIVEL_EDUCATIVO_MAX = '¿Cuál es el nivel máximo de educación culminado con éxito?';
export const CAMPO_NIVEL_EDUCATIVO = 'Nivel educativo';
export const CAMPO_NUCLEO_CONOCIMIENTO = 'Núcleo de conocimiento';
export const CAMPO_AREA_DESEMPENO = 'Área de desempeño';
export const CAMPO_TITULO_HOMOLOGADO = 'Título homologado';
export const CAMPO_MUNICIPIO_EMPRESA = 'Municipio (Experiencia laboral)';
// "Institución" y "Observaciones" se repiten literalmente en la nomenclatura oficial (una vez para
// Nivel educativo, otra para Capacitaciones) — Excel no admite dos columnas con el mismo encabezado
// en la misma hoja (ver el bug de sheet_to_json ya corregido para las columnas ocultas), así que se
// desambiguan con la misma convención que ya usa el propio listado oficial para "País"/"Estado"
// (p. ej. "País (Experiencia laboral)").
export const CAMPO_INSTITUCION_NIVEL_EDUCATIVO = 'Institución (Nivel educativo)';
export const CAMPO_OBSERVACIONES_NIVEL_EDUCATIVO = 'Observaciones (Nivel educativo)';
export const CAMPO_INSTITUCION_CAPACITACION = 'Institución (Capacitaciones y certificaciones)';

export const candidatos = {
	// Campos correspondientes al step "Datos del usuario" (UserManagement.tsx / Step1.tsx) MÁS los
	// Steps 1-4 de "Información básica" del registro de currículo (CurriculumRegistration.tsx /
	// steps/curriculum-registration/Step1-4.tsx). Nombres de columna alineados a la nomenclatura
	// definitiva de la plantilla completa de Candidatos (no inventar nombres nuevos).
	// Nota: "Grupo indígena" no tiene columna propia en la plantilla oficial; cuando "Grupo étnico"
	// resuelva al código de Indígena ese subcampo queda vacío a propósito (ver useCargueCandidatos.ts).
	// Orden exacto pedido por el usuario (mismo orden que la nomenclatura oficial completa, ver
	// project-cargue-masivo-columnas-futuras en memoria) — no es el orden en que se fueron agregando
	// las columnas por fases (Datos del usuario -> Steps 1-4 -> Steps 5-8).
	Headers: [
		'Primer nombre',
		'Segundo nombre',
		'Primer apellido',
		'Segundo apellido',
		'Nombre identitario',
		'Tipo de documento',
		'Número de documento',
		'Estado civil',
		'Sexo asignado al nacer',
		'Identidad de Género',
		'Orientación sexual',
		'Jefe o Jefa de hogar',
		'Fecha de nacimiento',
		'País de nacimiento',
		'Nacionalidad',
		CAMPO_DEPARTAMENTO_NACIMIENTO,
		CAMPO_MUNICIPIO_NACIMIENTO,
		'Libreta militar',
		'Tipo de libreta',
		'Número de libreta',
		'¿Cuenta con Sisbén?',
		'Tipo de Sisbén',
		'¿Usted es Cuidador o Cuidadora?',
		'Persona que recibe cuidado',
		'¿Se reconoce como parte de una población con mayores barreras para conseguir empleo?',
		...CamposTipoPoblacion.map((c) => c.campo),
		'Grupo étnico',
		'¿Es usted una persona con discapacidad?',
		'Tipo de discapacidad',
		'País del cual fue retornado',
		'Correo electrónico',
		'Teléfono',
		'Otro teléfono',
		'Observaciones',
		'País de residencia',
		CAMPO_DEPARTAMENTO_RESIDENCIA,
		CAMPO_MUNICIPIO_RESIDENCIA,
		CAMPO_LOCALIDAD,
		CAMPO_BARRIO,
		'Pertenece a zona',
		'Prestador de tu preferencia',
		'Punto de atención',
		...CamposDireccionResidencia.map((c) => c.campo),
		'Tipo de complemento (Dirección)',
		'Complemento (Dirección)',
		'Dirección de residencia',
		'Situación laboral actual',
		'Posibilidad de viajar',
		'Interés en ofertas de teletrabajo',
		'Posibilidad de trasladarse',
		'Conduce carro',
		'Categoría licencia para carro',
		'Conduce moto',
		'Categoría licencia para moto',
		'Propietario de su medio de transporte',
		'Perfil laboral',
		'¿Cuánto es tu salario actual o último salario?',
		'¿Cuál es su expectativa salarial en este momento?',
		'¿Cuál sería el salario mínimo aceptado en su trabajo soñado?',
		CAMPO_CARGO_DESEADO,
		'¿Tiene educación formal?',
		CAMPO_NIVEL_EDUCATIVO_MAX,
		CAMPO_NIVEL_EDUCATIVO,
		'Título obtenido',
		CAMPO_TITULO_HOMOLOGADO,
		// "Institución" y "Observaciones" se repiten en la nomenclatura oficial (Nivel educativo y
		// Capacitaciones); van desambiguadas por la razón ya explicada (Excel no admite dos columnas
		// con el mismo encabezado en una hoja) — ver comentario en las constantes CAMPO_* arriba.
		CAMPO_INSTITUCION_NIVEL_EDUCATIVO,
		'Estado del curso',
		'Fecha de finalización',
		CAMPO_OBSERVACIONES_NIVEL_EDUCATIVO,
		'Estoy interesado(a) en realizar una práctica empresarial',
		CAMPO_AREA_DESEMPENO,
		'País del título',
		'¿Tiene tarjeta profesional?',
		'Número de tarjeta profesional',
		'Fecha de expedición de tarjeta profesional',
		CAMPO_NUCLEO_CONOCIMIENTO,
		'¿Tiene experiencia laboral?',
		'Tipo de experiencia laboral',
		'Sector',
		'Cargo',
		'Cargo equivalente',
		'Nombre de la empresa',
		'Teléfono de la empresa',
		'País (Experiencia laboral)',
		'Departamento (Experiencia laboral)',
		CAMPO_MUNICIPIO_EMPRESA,
		'¿Este es su empleo actual?',
		'Fecha de ingreso',
		'Fecha de retiro',
		'Funciones y logros',
		'¿Tiene capacitaciones y certificaciones?',
		'Tipo capacitación o certificación',
		'Nombre del programa',
		CAMPO_INSTITUCION_CAPACITACION,
		'País (Capacitaciones y certificaciones)',
		'Estado (Capacitaciones y certificaciones)',
		'Fecha de certificación',
		'Duración en horas',
		'Agregar idioma',
		'Nivel idioma',
		'Tipo',
		'Herramientas',
		'Nivel',
	],
	// Obligatoriedad ajustada a la spec "Campos, obligatoriedad y regla" compartida por el usuario —
	// es la fuente de verdad para esta plantilla (en varios puntos difiere a propósito de las reglas
	// del wizard paso a paso, ver notas en useCargueCandidatos.ts donde aplica).
	CamposObligatorios: [
			'Primer nombre',
			'Primer apellido',
			'Tipo de documento',
			'Número de documento',
			'Sexo asignado al nacer',
			'Identidad de Género',
			'Orientación sexual',
			'Jefe o Jefa de hogar',
			'Fecha de nacimiento',
			'¿Usted es Cuidador o Cuidadora?',
			'¿Se reconoce como parte de una población con mayores barreras para conseguir empleo?',
			'Correo electrónico',
			'Teléfono',
			'País de residencia',
			CAMPO_DEPARTAMENTO_RESIDENCIA,
			CAMPO_MUNICIPIO_RESIDENCIA,
			'Pertenece a zona',
			'Prestador de tu preferencia',
			'Vía principal (Dirección)',
			'Número 1 (Dirección)',
			'Dirección de residencia',
			'Situación laboral actual',
			'Posibilidad de viajar',
			'Interés en ofertas de teletrabajo',
			'Posibilidad de trasladarse',
			'Conduce carro',
			'Conduce moto',
			'Propietario de su medio de transporte',
			'¿Cuánto es tu salario actual o último salario?',
			'¿Cuál es su expectativa salarial en este momento?',
		],
		// Obligatorios que dependen de otra columna (ver "Dependencia:" en Descripciones): se muestran como
		// [Obligatorio] en la plantilla y se validan con requerirSi en useCargueCandidatos.ts.
		CamposObligatoriosCondicionales: [
			CAMPO_DEPARTAMENTO_NACIMIENTO,
			CAMPO_MUNICIPIO_NACIMIENTO,
			'Libreta militar',
			'Número de libreta',
			'Persona que recibe cuidado',
			'Persona en habitabilidad en calle',
			'Persona en proceso de reincorporación, reintegración y/o desmovilización',
			'Joven mayor de 18 años que está o estuvo en protección del ICBF',
			'Vendedor informal en reconversión laboral',
			'Joven del sistema de responsabilidad penal adolescente',
			'Población postpenitenciaria – privada de la libertad al menos 3 meses',
			'Reciclador de oficio en reconversión laboral',
			'Persona en procesos de reintegración',
			'Retornado (persona que ha vivido en el extranjero y regresó al país)',
			'Persona que realiza actividades sexuales pagas',
			'Persona trans',
			'Víctima del conflicto armado',
			'Persona víctima de trata de personas',
			'Víctima de violencia basada en género (VVG)',
			'Grupo étnico',
			'¿Es usted una persona con discapacidad?',
			'Tipo de discapacidad',
			CAMPO_LOCALIDAD,
			CAMPO_BARRIO,
			'Punto de atención',
			'Complemento (Dirección)',
			'Categoría licencia para carro',
			'Categoría licencia para moto',
			CAMPO_NIVEL_EDUCATIVO_MAX,
			CAMPO_NIVEL_EDUCATIVO,
			'Título obtenido',
			CAMPO_INSTITUCION_NIVEL_EDUCATIVO,
			'Fecha de finalización',
			'¿Tiene tarjeta profesional?',
			'Número de tarjeta profesional',
			'Cargo',
			'Nombre de la empresa',
			'Fecha de ingreso',
			'Fecha de retiro',
			CAMPO_NUCLEO_CONOCIMIENTO,
		],
		// Tipo de dato mostrado en la fila 2 de la plantilla (literal de la plantilla oficial).
		TiposDato: {
			'Primer nombre': 'Texto',
			'Segundo nombre': 'Texto',
			'Primer apellido': 'Texto',
			'Segundo apellido': 'Texto',
			'Nombre identitario': 'Texto',
			'Tipo de documento': 'Texto (catálogo)',
			'Número de documento': 'Texto/Numérico',
			'Estado civil': 'Texto (catálogo)',
			'Sexo asignado al nacer': 'Texto (catálogo)',
			'Identidad de Género': 'Texto (catálogo)',
			'Orientación sexual': 'Texto (catálogo)',
			'Jefe o Jefa de hogar': 'Texto (catálogo)',
			'Fecha de nacimiento': 'Fecha (DD/MM/AAAA)',
			'País de nacimiento': 'Texto (catálogo)',
			'Nacionalidad': 'Texto (catálogo)',
			[CAMPO_DEPARTAMENTO_NACIMIENTO]: 'Texto (catálogo)',
			[CAMPO_MUNICIPIO_NACIMIENTO]: 'Texto (catálogo)',
			'Libreta militar': 'Texto (catálogo)',
			'Tipo de libreta': 'Texto (catálogo)',
			'Número de libreta': 'Numérico entero',
			'¿Cuenta con Sisbén?': 'Texto (catálogo)',
			'Tipo de Sisbén': 'Texto (catálogo)',
			'¿Usted es Cuidador o Cuidadora?': 'Texto (catálogo)',
			'Persona que recibe cuidado': 'Texto (catálogo)',
			'¿Se reconoce como parte de una población con mayores barreras para conseguir empleo?': 'Texto (catálogo)',
			'Persona en habitabilidad en calle': 'Checklist',
			'Persona en proceso de reincorporación, reintegración y/o desmovilización': 'Checklist',
			'Joven mayor de 18 años que está o estuvo en protección del ICBF': 'Checklist',
			'Vendedor informal en reconversión laboral': 'Checklist',
			'Joven del sistema de responsabilidad penal adolescente': 'Checklist',
			'Población postpenitenciaria – privada de la libertad al menos 3 meses': 'Checklist',
			'Reciclador de oficio en reconversión laboral': 'Checklist',
			'Persona en procesos de reintegración': 'Checklist',
			'Retornado (persona que ha vivido en el extranjero y regresó al país)': 'Checklist',
			'Persona que realiza actividades sexuales pagas': 'Checklist',
			'Persona trans': 'Checklist',
			'Víctima del conflicto armado': 'Checklist',
			'Persona víctima de trata de personas': 'Checklist',
			'Víctima de violencia basada en género (VVG)': 'Checklist',
			'Grupo étnico': 'Texto (catálogo)',
			'¿Es usted una persona con discapacidad?': 'Texto (catálogo)',
			'Tipo de discapacidad': 'Texto (catálogo)',
			'País del cual fue retornado': 'Texto (catálogo)',
			'Correo electrónico': 'Texto (email)',
			'Teléfono': 'Numérico entero',
			'Otro teléfono': 'Numérico entero',
			'Observaciones': 'Texto',
			'País de residencia': 'Texto (catálogo)',
			[CAMPO_DEPARTAMENTO_RESIDENCIA]: 'Texto (catálogo)',
			[CAMPO_MUNICIPIO_RESIDENCIA]: 'Texto (catálogo)',
			[CAMPO_LOCALIDAD]: 'Texto (catálogo)',
			[CAMPO_BARRIO]: 'Texto (catálogo)',
			'Pertenece a zona': 'Texto (catálogo)',
			'Prestador de tu preferencia': 'Texto (catálogo)',
			'Punto de atención': 'Texto (catálogo)',
			'Vía principal (Dirección)': 'Texto (catálogo)',
			'Número 1 (Dirección)': 'Texto/Numérico entero',
			'Letra 1 (Dirección)': 'Texto (catálogo)',
			'BIS 1 (Dirección)': 'Texto (catálogo)',
			'Letra 2 (Dirección)': 'Texto (catálogo)',
			'Cardinalidad 1 (Dirección)': 'Texto (catálogo)',
			'Número 2 (Dirección)': 'Numérico entero',
			'Letra 3 (Dirección)': 'Texto (catálogo)',
			'Número 3 (Dirección)': 'Numérico entero',
			'Cardinalidad 2 (Dirección)': 'Texto (catálogo)',
			'Tipo de complemento (Dirección)': 'Texto (catálogo)',
			'Complemento (Dirección)': 'Texto/Numérico entero',
			'Dirección de residencia': 'Lectura (Texto)',
			'Situación laboral actual': 'Texto (catálogo)',
			'Posibilidad de viajar': 'Texto (catálogo)',
			'Interés en ofertas de teletrabajo': 'Texto (catálogo)',
			'Posibilidad de trasladarse': 'Texto (catálogo)',
			'Conduce carro': 'Texto (catálogo)',
			'Categoría licencia para carro': 'Texto (catálogo)',
			'Conduce moto': 'Texto (catálogo)',
			'Categoría licencia para moto': 'Texto (catálogo)',
			'Propietario de su medio de transporte': 'Texto (catálogo)',
			'Perfil laboral': 'Texto',
			'¿Cuánto es tu salario actual o último salario?': 'Texto (catálogo)',
			'¿Cuál es su expectativa salarial en este momento?': 'Texto (catálogo)',
			'¿Cuál sería el salario mínimo aceptado en su trabajo soñado?': 'Texto (catálogo)',
			'¿En qué le gustaría trabajar?': 'Texto (catálogo)',
			'¿Tiene educación formal?': 'Texto (catálogo)',
			[CAMPO_NIVEL_EDUCATIVO_MAX]: 'Texto (catálogo)',
			[CAMPO_NIVEL_EDUCATIVO]: 'Texto (catálogo)',
			'Título obtenido': 'Texto',
			'Título homologado': 'Texto (catálogo)',
			[CAMPO_INSTITUCION_NIVEL_EDUCATIVO]: 'Texto',
			'Estado del curso': 'Texto (catálogo)',
			'Fecha de finalización': 'Fecha (DD/MM/AAAA)',
			'Observaciones (Nivel educativo)': 'Texto',
			'Estoy interesado(a) en realizar una práctica empresarial': 'Checkbox',
			'Área de desempeño': 'Texto (catálogo)',
			'País del título': 'Texto (catálogo)',
			'¿Tiene tarjeta profesional?': 'Texto (catálogo)',
			'Número de tarjeta profesional': 'Numérico entero',
			'Fecha de expedición de tarjeta profesional': 'Fecha (DD/MM/AAAA)',
			[CAMPO_NUCLEO_CONOCIMIENTO]: 'Texto (catálogo)',
			'¿Tiene experiencia laboral?': 'Texto (catálogo)',
			'Tipo de experiencia laboral': 'Texto (catálogo)',
			'Sector': 'Texto (catálogo)',
			'Cargo': 'Texto',
			'Cargo equivalente': 'Texto',
			'Nombre de la empresa': 'Texto',
			'Teléfono de la empresa': 'Numérico entero',
			'País (Experiencia laboral)': 'Texto (catálogo)',
			'Departamento (Experiencia laboral)': 'Texto (catálogo)',
			'Municipio (Experiencia laboral)': 'Texto (catálogo)',
			'¿Este es su empleo actual?': 'Checkbox',
			'Fecha de ingreso': 'Fecha (DD/MM/AAAA)',
			'Fecha de retiro': 'Fecha (DD/MM/AAAA)',
			'Funciones y logros': 'Texto',
			'¿Tiene capacitaciones y certificaciones?': 'Texto (catálogo)',
			'Tipo capacitación o certificación': 'Texto (catálogo)',
			'Nombre del programa': 'Texto',
			'Institución (Capacitaciones y certificaciones)': 'Texto',
			'País (Capacitaciones y certificaciones)': 'Texto (catálogo)',
			'Estado (Capacitaciones y certificaciones)': 'Texto (catálogo)',
			'Fecha de certificación': 'Fecha (DD/MM/AAAA)',
			'Duración en horas': 'Numérico entero',
			'Agregar idioma': 'Texto (catálogo)',
			'Nivel idioma': 'Texto (catálogo)',
			'Tipo': 'Texto (catálogo)',
			'Herramientas': 'Texto',
			'Nivel': 'Escala',
		} as Record<string, string>,
		LimitesCaracteres: [
		{ campo: 'Primer nombre', min: 2, max: 40 },
		{ campo: 'Segundo nombre', min: 2, max: 40 },
		{ campo: 'Primer apellido', min: 2, max: 40 },
		{ campo: 'Segundo apellido', min: 2, max: 40 },
		{ campo: 'Correo electrónico', max: 80 },
		{ campo: 'Nombre identitario', min: 10, max: 30 },
		{ campo: 'Observaciones', min: 10, max: 1200 },
		{ campo: 'Complemento (Dirección)', max: 100 },
		{ campo: 'Dirección de residencia', max: 500 },
		{ campo: 'Perfil laboral', min: 100, max: 1200 },
		{ campo: 'Título obtenido', min: 4, max: 40 },
		{ campo: CAMPO_INSTITUCION_NIVEL_EDUCATIVO, min: 4, max: 40 },
		{ campo: CAMPO_OBSERVACIONES_NIVEL_EDUCATIVO, min: 300, max: 1200 },
		{ campo: 'Sector', min: 4, max: 40 },
		{ campo: 'Cargo', min: 4, max: 40 },
		{ campo: 'Cargo equivalente', min: 4, max: 40 },
		{ campo: 'Nombre de la empresa', min: 4, max: 40 },
		{ campo: 'Funciones y logros', min: 10, max: 1200 },
		{ campo: 'Nombre del programa', min: 4, max: 40 },
		{ campo: CAMPO_INSTITUCION_CAPACITACION, min: 4, max: 40 },
		{ campo: 'Herramientas', min: 4, max: 40 },
	],
	// 'Número de documento' NO va acá como campo único aislado: la regla de negocio es que la
	// duplicidad dentro del archivo se valida por la COMBINACIÓN Tipo de documento + Número de
	// documento (ver chequeo dedicado en validarCandidatoCarga, useCargueCandidatos.ts), no por el
	// número solo (dos filas podrían compartir número con tipos de documento distintos).
	CamposUnicos: [
		'Correo electrónico',
	],
	camposEnParametros: [
		{ campo: 'Tipo de documento', tipo: parameters.TIPODOCUMENTO },
		{ campo: 'Sexo asignado al nacer', tipo: parameters.SEXO },
		// --- Steps 1-4: catálogos planos de `parameters`, todos con dropdown nativo (columnas ocultas
		// en la misma hoja, ver escribirColumnaListaOculta en useCargueCandidatos.ts). Los campos que
		// dependen de otra columna (Municipio, Barrio, Localidad, Cargo deseado) NO van aquí. ---
		{ campo: 'Estado civil', tipo: parameters.ESTADOCIVIL },
		{ campo: 'Identidad de Género', tipo: parameters.GENERO },
		{ campo: 'Orientación sexual', tipo: parameters.ORIENTACIONSEXUAL },
		{ campo: 'Jefe o Jefa de hogar', tipo: parameters.SINO },
		{ campo: 'País de nacimiento', tipo: parameters.PAIS },
		{ campo: 'Nacionalidad', tipo: parameters.NACIONALIDAD },
		{ campo: CAMPO_DEPARTAMENTO_NACIMIENTO, tipo: parameters.DEPARTAMENTO },
		{ campo: 'Libreta militar', tipo: parameters.SINO },
		{ campo: 'Tipo de libreta', tipo: parameters.TIPOLIBRETA },
		{ campo: '¿Cuenta con Sisbén?', tipo: parameters.SINO },
		{ campo: 'Tipo de Sisbén', tipo: parameters.SISBEN },
		{ campo: '¿Usted es Cuidador o Cuidadora?', tipo: parameters.SINO },
		{ campo: 'Persona que recibe cuidado', tipo: parameters.PERSONACUIDADA },
		{ campo: '¿Se reconoce como parte de una población con mayores barreras para conseguir empleo?', tipo: parameters.SINO },
		...CamposTipoPoblacion.map((c) => ({ campo: c.campo, tipo: parameters.SINO })),
		{ campo: 'Grupo étnico', tipo: parameters.GRUPOETNICO },
		{ campo: '¿Es usted una persona con discapacidad?', tipo: parameters.SINO },
		{ campo: 'Tipo de discapacidad', tipo: parameters.DISCAPACIDADES },
		{ campo: 'País del cual fue retornado', tipo: parameters.PAIS },
		{ campo: 'País de residencia', tipo: parameters.PAIS },
		{ campo: CAMPO_DEPARTAMENTO_RESIDENCIA, tipo: parameters.DEPARTAMENTO },
		{ campo: 'Pertenece a zona', tipo: parameters.ZONA },
		{ campo: 'Prestador de tu preferencia', tipo: parameters.PRESTADORPREFERENCIA },
		{ campo: 'Punto de atención', tipo: parameters.PUNTOATENCION },
		{ campo: 'Vía principal (Dirección)', tipo: parameters.VIAPRINCIPAL },
		{ campo: 'Letra 1 (Dirección)', tipo: parameters.VIAPRINCIPALPRIMERALETRA },
		{ campo: 'BIS 1 (Dirección)', tipo: parameters.VIAPRINCIPALBIS },
		{ campo: 'Letra 2 (Dirección)', tipo: parameters.VIAPRINCIPALPRIMERALETRA },
		{ campo: 'Cardinalidad 1 (Dirección)', tipo: parameters.VIAPRINCIPALCUADRANTE },
		{ campo: 'Letra 3 (Dirección)', tipo: parameters.VIAPRINCIPALPRIMERALETRA },
		{ campo: 'Cardinalidad 2 (Dirección)', tipo: parameters.VIAPRINCIPALCUADRANTE },
		{ campo: 'Tipo de complemento (Dirección)', tipo: parameters.VIAPRINCIPALDIRECCION },
		{ campo: 'Situación laboral actual', tipo: parameters.SITUACIONLABORAL },
		{ campo: 'Posibilidad de viajar', tipo: parameters.SINO },
		{ campo: 'Interés en ofertas de teletrabajo', tipo: parameters.SINO },
		{ campo: 'Posibilidad de trasladarse', tipo: parameters.SINO },
		{ campo: 'Conduce carro', tipo: parameters.SINO },
		{ campo: 'Categoría licencia para carro', tipo: parameters.LINCENCIACARRO },
		{ campo: 'Conduce moto', tipo: parameters.SINO },
		{ campo: 'Categoría licencia para moto', tipo: parameters.LINCENCIAMOTO },
		{ campo: 'Propietario de su medio de transporte', tipo: parameters.SINO },
		{ campo: '¿Cuánto es tu salario actual o último salario?', tipo: parameters.SALARIOMENSUAL },
		{ campo: '¿Cuál es su expectativa salarial en este momento?', tipo: parameters.SALARIOMENSUAL },
		{ campo: '¿Cuál sería el salario mínimo aceptado en su trabajo soñado?', tipo: parameters.SALARIOMENSUAL },
		// --- Steps 5-8 ---
		{ campo: '¿Tiene educación formal?', tipo: parameters.SINO },
		{ campo: 'Estado del curso', tipo: parameters.ESTADOCURSO },
		{ campo: 'Estoy interesado(a) en realizar una práctica empresarial', tipo: parameters.SINO },
		{ campo: 'País del título', tipo: parameters.PAIS },
		{ campo: '¿Tiene tarjeta profesional?', tipo: parameters.SINO },
		{ campo: '¿Tiene experiencia laboral?', tipo: parameters.SINO },
		{ campo: 'Tipo de experiencia laboral', tipo: parameters.TIPOEXPERIENCIALABORAL },
		{ campo: 'Sector', tipo: parameters.SECTORINDUSTRIAL },
		{ campo: 'País (Experiencia laboral)', tipo: parameters.PAIS },
		{ campo: 'Departamento (Experiencia laboral)', tipo: parameters.DEPARTAMENTO },
		{ campo: '¿Este es su empleo actual?', tipo: parameters.SINO },
		{ campo: '¿Tiene capacitaciones y certificaciones?', tipo: parameters.SINO },
		{ campo: 'Tipo capacitación o certificación', tipo: parameters.TIPOCAPACITACION },
		{ campo: 'País (Capacitaciones y certificaciones)', tipo: parameters.PAIS },
		{ campo: 'Estado (Capacitaciones y certificaciones)', tipo: parameters.ESTADOCERTIFICADO },
		{ campo: 'Agregar idioma', tipo: parameters.IDIOMA },
		{ campo: 'Nivel idioma', tipo: parameters.NIVELIDIOMA },
		{ campo: 'Tipo', tipo: parameters.TIPOCONOCIMIENTOS },
	],
	// Regla de validación mostrada en la fila 3 de la plantilla (mismo formato usado por Empresas/Vacantes).
	Descripciones: {
		'Tipo de documento': 'Valores permitidos: Debe corresponder a un valor activo del catálogo del sistema de la tabla TIPODOCUMENTO',
		'Número de documento': 'No duplicidad: la combinación tipo + número no debe existir en el sistema.',
		'Primer nombre': 'Mínimo 2 caracteres. Máximo 40 caracteres',
		'Segundo nombre': 'Mínimo 2 caracteres. Máximo 40 caracteres',
		'Primer apellido': 'Mínimo 2 caracteres. Máximo 40 caracteres',
		'Segundo apellido': 'Mínimo 2 caracteres. Máximo 40 caracteres',
		'Sexo asignado al nacer': 'Valores permitidos: Debe corresponder a un valor activo del catálogo del sistema de la tabla SEXO',
		'Teléfono': 'Valores permitidos: El valor ingresado debe contener 7 o 10 dígitos.',
		'Correo electrónico': 'Formato válido de email. No duplicidad en la plataforma.',
		'Nombre identitario': 'Mínimo 10 caracteres. Máximo 30 caracteres.',
		'Estado civil': 'Valores permitidos: Debe corresponder a un valor activo del catálogo del sistema de la tabla ESTADOCIVIL',
		'Identidad de Género': 'Valores permitidos: Debe corresponder a un valor activo del catálogo del sistema de la tabla GENERO',
		'Orientación sexual': 'Valores permitidos: Debe corresponder a un valor activo del catálogo del sistema de la tabla ORIENTACIONSEXUAL',
		'Jefe o Jefa de hogar': 'Valores permitidos: Debe corresponder a un valor activo del catálogo del sistema de la tabla SINO',
		'Fecha de nacimiento': 'Valores permitidos: Depende del tipo de documento si es: Tarjeta de identidad (entre 7 y 17 años), Cédula de Ciudadanía (más de 17 años), Cédula de Extranjería (sin restricción), PEP (sin restricción), PPT (sin restricción).',
		'País de nacimiento': 'Valores permitidos: Debe corresponder a un valor activo del catálogo del sistema de la tabla PAIS Columna value.',
		'Nacionalidad': 'Valores permitidos: Debe corresponder a un valor activo del catálogo del sistema de la tabla NACIONALIDAD Columna value y que corresponda a la pareja del valor seleccionado en el campo “País de nacimiento”.',
		[CAMPO_DEPARTAMENTO_NACIMIENTO]: 'Valores permitidos: Debe corresponder a un valor activo del catálogo del sistema de la tabla DEPARTAMENTO. Dependencia: Este campo se habilita si el valor seleccionado del campo “País de nacimiento”(Tabla PAIS), es “Colombia”.',
		[CAMPO_MUNICIPIO_NACIMIENTO]: 'Valores permitidos: Debe corresponder a un valor activo del catálogo del sistema de la tabla MUNICIPIO. Dependencia: Este campo se habilita si el valor seleccionado del campo “País de nacimiento”(Tabla PAIS), es “Colombia”. Los valores dependen del “Departamento de nacimiento”.',
		'Libreta militar': 'Valores permitidos: Debe corresponder a un valor activo del catálogo del sistema de la tabla SINO. Dependencia: Este campo se habilita si el valor seleccionado del campo “Sexo asignado al nacer”, es “Hombre”.',
		'Tipo de libreta': 'Valores permitidos: Debe corresponder a un valor activo del catálogo del sistema de la tabla TIPOLIBRETA. Dependencia: Este campo se habilita si el valor de “Libreta militar” es “SI”.',
		'Número de libreta': 'Mínimo 6 dígitos. Máximo 10 dígitos. Dependencia: Este campo se habilita si el valor de “Libreta militar” es “SI”.',
		'¿Cuenta con Sisbén?': 'Valores permitidos: Debe corresponder a un valor activo del catálogo del sistema de la tabla SINO.',
		'Tipo de Sisbén': 'Valores permitidos: Debe corresponder a un valor activo del catálogo del sistema de la tabla SISBEN. Dependencia: Se habilita si “¿Cuenta con Sisbén?” es “SI”.',
		'¿Usted es Cuidador o Cuidadora?': 'Valores permitidos: Debe corresponder a un valor activo del catálogo del sistema de la tabla SINO.',
		'Persona que recibe cuidado': 'Valores permitidos: Debe corresponder a un valor activo del catálogo del sistema de la tabla PERSONACUIDADA. Dependencia: Se habilita si “¿Usted es Cuidador o Cuidadora?” es “SI”.',
		'¿Se reconoce como parte de una población con mayores barreras para conseguir empleo?': 'Valores permitidos: Debe corresponder a un valor activo del catálogo del sistema de la tabla SINO. Regla: Si se selecciona “SI”, al menos una pregunta dependiente debe responderse con “SI”.',
		...Object.fromEntries(
			CamposTipoPoblacion.map((c) => [c.campo, 'Valores permitidos: SI/NO (Marca/No marca). Dependencia: Se habilita si “¿Se reconoce como parte de una población...?” es “SI”.'])
		),
		'Grupo étnico': 'Valores permitidos: Debe corresponder a un valor activo del catálogo del sistema de la tabla GRUPOETNICO. Dependencia: Se habilita si “¿Se reconoce como parte de una población...?” es “SI”.',
		'¿Es usted una persona con discapacidad?': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla SINO. Dependencia: Se habilita si “¿Se reconoce como parte de una población...?” es “SI”.',
		'Tipo de discapacidad': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla DISCAPACIDADES. Dependencia: Se habilita si “¿Es usted una persona con discapacidad?” es “SI”.',
		'País del cual fue retornado': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla PAIS. Dependencia: Se habilita si “Retornado” es “SI”.',
		'Otro teléfono': 'Valores permitidos: El valor ingresado debe contener 7 o 10 dígitos.',
		'Observaciones': 'Mínimo 10 caracteres. Máximo 1200 caracteres.',
		'País de residencia': 'Valores permitidos: Debe corresponder al valor “Colombia”',
		[CAMPO_DEPARTAMENTO_RESIDENCIA]: 'Valores permitidos: Debe corresponder al valor “BOGOTÁ, D.C.” o “CUNDINAMARCA”.',
		[CAMPO_MUNICIPIO_RESIDENCIA]: 'Debe corresponder a un valor activo del catálogo del sistema de la tabla MUNICIPIO. Dependencia: Los valores dependen del “Departamento de residencia”.',
		[CAMPO_LOCALIDAD]: 'Debe corresponder a un valor activo de la lista de valores de Localidad del sistema: ANTONIO NARIÑO, BARRIOS UNIDOS, BOSA, CHAPINERO, CIUDAD BOLIVAR, ENGATIVÁ, FONTIBÓN, KENNEDY, LA CANDELARIA, LOS MÁRTIRES, PUENTE ARANDA, RAFAEL URIBE URIBE, SAN CRISTOBAL, SANTA FE, SUBA, SUMAPAZ, TEUSAQUILLO, TUNJUELITO, USAQUEN, USME. Dependencia: Se habilita si “Departamento de residencia” es “BOGOTÁ, D.C.”.',
		[CAMPO_BARRIO]: 'Debe corresponder a un valor activo de la lista de valores de barrios del sistema. Dependencia: Se habilita si “Departamento de residencia” es “BOGOTÁ, D.C.”.\n\nLos valores a seleccionar del catálogo dependen del valor seleccionado en el campo “Localidad”.',
		'Pertenece a zona': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla ZONA.',
		'Prestador de tu preferencia': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla PRESTADORPREFERENCIA. Dependencia: Se habilita si “Departamento de residencia” es “BOGOTÁ, D.C.”.',
		'Punto de atención': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla PUNTOATENCION. Dependencia: Se habilita si “Departamento de residencia” es “BOGOTÁ, D.C.”.',
		'Vía principal (Dirección)': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla VIAPRINCIPAL.',
		'Número 1 (Dirección)': 'Valores permitidos: si se ingresa un número debe ser mayor o igual que 0.',
		'Letra 1 (Dirección)': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla VIAPRINCIPALPRIMERALETRA.',
		'BIS 1 (Dirección)': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla VIAPRINCIPALBIS.',
		'Letra 2 (Dirección)': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla VIAPRINCIPALPRIMERALETRA.',
		'Cardinalidad 1 (Dirección)': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla VIAPRINCIPALCUADRANTE.',
		'Número 2 (Dirección)': 'Valores permitidos: si se ingresa un número debe ser mayor o igual que 0.',
		'Letra 3 (Dirección)': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla VIAPRINCIPALPRIMERALETRA.',
		'Número 3 (Dirección)': 'Valores permitidos: si se ingresa un número debe ser mayor o igual que 0.',
		'Cardinalidad 2 (Dirección)': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla VIAPRINCIPALCUADRANTE.',
		'Tipo de complemento (Dirección)': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla VIAPRINCIPALDIRECCION.',
		'Complemento (Dirección)': 'Valores permitidos: si se ingresa un número debe ser mayor que 0. Dependencia: Se habilita si se selecciona un "Tipo de complemento".',
		'Dirección de residencia': 'Campo donde se visualiza la concatenación de los elementos de la dirección ingresada.',
		'Situación laboral actual': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla SITUACIONLABORAL.',
		'Posibilidad de viajar': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla SINO.',
		'Interés en ofertas de teletrabajo': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla SINO.',
		'Posibilidad de trasladarse': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla SINO.',
		'Conduce carro': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla SINO.',
		'Categoría licencia para carro': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla LINCENCIACARRO. Dependencia: Se habilita si “Conduce carro” es “SI”.',
		'Conduce moto': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla SINO.',
		'Categoría licencia para moto': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla LINCENCIAMOTO. Dependencia: Se habilita si “Conduce moto” es “SI”.',
		'Propietario de su medio de transporte': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla SINO.',
		'Perfil laboral': 'Mínimo 100 caracteres. Máximo 1200 caracteres.',
		'¿Cuánto es tu salario actual o último salario?': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla SALARIOMENSUAL. Regla: Los únicos valores que no pueden utilizarse del catálogo del sistema son: 0, -1',
		'¿Cuál es su expectativa salarial en este momento?': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla SALARIOMENSUAL. Regla: Los únicos valores que no pueden utilizarse del catálogo del sistema son: 0, -1',
		'¿Cuál sería el salario mínimo aceptado en su trabajo soñado?': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla SALARIOMENSUAL. Regla: Los únicos valores que no pueden utilizarse del catálogo del sistema son: 0, -1. El valor ingresado debe ser inferior o igual al del campo “¿Cuál es su expectativa salarial en este momento?”',
		[CAMPO_CARGO_DESEADO]: 'Debe corresponder a un valor activo de lista de valores asociada a la estructura CUOC a nivel de ocupación (678 valores).',
		// --- Steps 5-8 ---
		'¿Tiene educación formal?': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla SINO.',
		[CAMPO_NIVEL_EDUCATIVO_MAX]: 'Debe corresponder a un valor activo del catálogo del sistema de la tabla NIVELEDUCATIVO. Dependencia: Se habilita si “¿Tiene educación formal?” es “SI”.',
		[CAMPO_NIVEL_EDUCATIVO]: 'Debe corresponder a un valor activo del catálogo del sistema de la tabla NIVELEDUCATIVO. Dependencia: Se habilita si “¿Tiene educación formal?” es “SI”.',
		'Título obtenido': 'Mínimo 4 caracteres. Máximo 40 caracteres. Dependencia: Se habilita si “¿Tiene educación formal?” es “SI”.',
		[CAMPO_TITULO_HOMOLOGADO]: 'Debe corresponder a un valor activo de lista de valores asociada. Dependencia: Se habilita si “¿Tiene educación formal?” es “SI” y “Nivel educativo” != “Técnica laboral”.',
		[CAMPO_INSTITUCION_NIVEL_EDUCATIVO]: 'Mínimo 4 caracteres. Máximo 40 caracteres. Dependencia: Se habilita si “¿Tiene educación formal?” es “SI”.',
		'Estado del curso': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla ESTADOCURSO. Dependencia: Se habilita si “¿Tiene educación formal?” es “SI”.',
		'Fecha de finalización': 'Valores permitidos: Debe ser anterior o igual a la fecha del sistema. Dependencia: Se habilita si “¿Tiene educación formal?” es “SI” y “Estado del curso” es “Graduado”.',
		[CAMPO_OBSERVACIONES_NIVEL_EDUCATIVO]: 'Mínimo 300 caracteres. Máximo 1200 caracteres. Dependencia: Se habilita si “¿Tiene educación formal?” es “SI”.',
		'Estoy interesado(a) en realizar una práctica empresarial': 'Valores permitidos: SI/NO (Marca)/(No se marca). Dependencia: Se habilita si “¿Tiene educación formal?” es “SI”.',
		[CAMPO_AREA_DESEMPENO]: 'Debe corresponder a un valor activo de lista de valores asociada: FINANZAS Y ADMINISTRACIÓN; CIENCIAS NATURALES, APLICADAS Y RELACIONADAS; SALUD; CIENCIAS SOCIALES, EDUCACIÓN, SERVICIOS GUBERNAMENTALES Y RELIGIÓN; ARTE, CULTURA, ESPARCIMIENTO Y DEPORTES; VENTAS Y SERVICIOS; EXPLOTACIÓN PRIMARIA Y EXTRACTIVA; OPERACIÓN DE EQUIPOS, DEL TRANSPORTE Y OFICIOS; PROCESAMIENTO, FABRICACIÓN Y ENSAMBLAJE. Dependencia: Se habilita si “¿Tiene educación formal?” es “SI” y “Nivel educativo” es “Técnica laboral”.',
		'País del título': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla PAIS. Dependencia: Se habilita si “¿Tiene educación formal?” es “SI” y “Nivel educativo” es alguna de: Técnica laboral, Técnica profesional, Tecnológica, Universitaria, Especialización, Maestría, Doctorado.',
		'¿Tiene tarjeta profesional?': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla SINO. Dependencia: Se habilita si “¿Tiene educación formal?” es “SI”, “Estado del curso” es “Graduado” y nivel educativo es de educación superior.',
		'Número de tarjeta profesional': 'Mínimo 4 dígitos. Máximo 10 dígitos. Dependencia: Se habilita si “¿Tiene tarjeta profesional?” es “SI”.',
		'Fecha de expedición de tarjeta profesional': 'Valores permitidos: Debe ser anterior o igual a la fecha del sistema. Dependencia: Se habilita si “¿Tiene tarjeta profesional?” es “SI”.',
		[CAMPO_NUCLEO_CONOCIMIENTO]: 'Debe corresponder a un valor activo de lista de valores asociada: ADMINISTRACIÓN; AGRONOMÍA; ARQUITECTURA; ARTES PLÁSTICAS, VISUALES Y AFINES; ARTES REPRESENTATIVAS; BACTERIOLOGÍA; BIBLIOTECOLOGÍA, OTROS DE CIENCIAS SOCIALES Y HUMANAS; BIOLOGÍA, MICROBIOLOGÍA Y AFINES; CIENCIA POLÍTICA, RELACIONES INTERNACIONALES; COMUNICACIÓN SOCIAL, PERIODISMO Y AFINES; CONTADURÍA PÚBLICA; DEPORTES, EDUCACIÓN FÍSICA Y RECREACIÓN; DERECHO Y AFINES; DISEÑO; ECONOMÍA; EDUCACIÓN; ENFERMERÍA; FISICA; FORMACIÓN RELACIONADA CON EL CAMPO MILITAR O POLICIAL; GEOLOGÍA, OTROS PROGRAMAS DE CIENCIAS NATURALES; INGENIERÍA ADMINISTRATIVA Y AFINES; INGENIERÍA AGRÍCOLA, FORESTAL Y AFINES; INGENIERÍA AGROINDUSTRIAL, ALIMENTOS Y AFINES; INGENIERÍA AGRONÓMICA, PECUARIA Y AFINES; INGENIERÍA AMBIENTAL, SANITARIA Y AFINES; INGENIERÍA BIOMÉDICA Y AFINES; INGENIERÍA CIVIL Y AFINES; INGENIERÍA DE MINAS, METALURGIA Y AFINES; INGENIERÍA DE SISTEMAS, TELEMÁTICA Y AFINES; INGENIERÍA ELÉCTRICA Y AFINES; INGENIERÍA ELECTRÓNICA, TELECOMUNICACIONES Y AFINES; INGENIERÍA INDUSTRIAL Y AFINES; INGENIERÍA MECÁNICA Y AFINES; INGENIERÍA QUÍMICA Y AFINES; INSTRUMENTACIÓN QUIRÚRGICA; LENGUAS MODERNAS, LITERATURA, LINGÜÍSTICA Y AFINES; MEDICINA; MÚSICA; NUTRICIÓN Y DIETÉTICA; ODONTOLOGÍA; OPTOMETRÍA, OTROS PROGRAMAS DE CIENCIAS DE LA SALUD; OTRAS INGENIERÍAS; OTROS PROGRAMAS ASOCIADOS A BELLAS ARTES; PSICOLOGÍA; PUBLICIDAD Y AFINES; SALUD PÚBLICA; SIN CLASIFICAR; SOCIOLOGÍA, TRABAJO SOCIAL Y AFINES; TERAPIAS; ZOOTECNIA.',
		'¿Tiene experiencia laboral?': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla SINO.',
		'Tipo de experiencia laboral': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla TIPOEXPERIENCIALABORAL. Dependencia: Se habilita si “¿Tiene experiencia laboral?” es “SI”.',
		'Sector': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla SECTORINDUSTRIAL. Dependencia: Se habilita si “¿Tiene experiencia laboral?” es “SI”.',
		'Cargo': 'Mínimo 4 caracteres. Máximo 40 caracteres. Dependencia: Se habilita si “¿Tiene experiencia laboral?” es “SI”.',
		'Cargo equivalente': 'Mínimo 4 caracteres. Máximo 40 caracteres. Dependencia: Se habilita si “¿Tiene experiencia laboral?” es “SI”.',
		'Nombre de la empresa': 'Mínimo 4 caracteres. Máximo 40 caracteres. Dependencia: Se habilita si “¿Tiene experiencia laboral?” es “SI”.',
		'Teléfono de la empresa': 'Valores permitidos: El valor ingresado debe contener 7 o 10 dígitos. Dependencia: Se habilita si “¿Tiene experiencia laboral?” es “SI”.',
		'País (Experiencia laboral)': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla PAIS. Dependencia: Se habilita si “¿Tiene experiencia laboral?” es “SI”.',
		'Departamento (Experiencia laboral)': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla DEPARTAMENTO. Dependencia: Se habilita si “¿Tiene experiencia laboral?” es “SI” y País de experiencia es “Colombia”.',
		[CAMPO_MUNICIPIO_EMPRESA]: 'Debe corresponder a un valor activo del catálogo del sistema de la tabla MUNICIPIO. Dependencia: Se habilita si “¿Tiene experiencia laboral?” es “SI” y País de experiencia es “Colombia”.',
		'¿Este es su empleo actual?': 'Valores permitidos: SI/NO (Marca)/(No se marca). Dependencia: Se habilita si “¿Tiene experiencia laboral?” es “SI”.',
		'Fecha de ingreso': 'Valores permitidos: Debe ser anterior o igual a la fecha del sistema. Dependencia: Se habilita si “¿Tiene experiencia laboral?” es “SI”.',
		'Fecha de retiro': 'Valores permitidos: Debe ser anterior o igual a la fecha del sistema y posterior o igual a Fecha de ingreso. Dependencia: Se habilita si “¿Tiene experiencia laboral?” es “SI” y “¿Este es su empleo actual?” es “NO”.',
		'Funciones y logros': 'Mínimo 10 caracteres. Máximo 1200 caracteres. Dependencia: Se habilita si “¿Tiene experiencia laboral?” es “SI”.',
		'¿Tiene capacitaciones y certificaciones?': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla SINO.',
		'Tipo capacitación o certificación': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla TIPOCAPACITACION. Dependencia: Se habilita si “¿Tiene capacitaciones y certificaciones?” es “SI”.',
		'Nombre del programa': 'Mínimo 4 caracteres. Máximo 40 caracteres. Dependencia: Se habilita si “¿Tiene capacitaciones y certificaciones?” es “SI”.',
		[CAMPO_INSTITUCION_CAPACITACION]: 'Mínimo 4 caracteres. Máximo 40 caracteres. Dependencia: Se habilita si “¿Tiene capacitaciones y certificaciones?” es “SI”.',
		'País (Capacitaciones y certificaciones)': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla PAIS. Dependencia: Se habilita si “¿Tiene capacitaciones y certificaciones?” es “SI”.',
		'Estado (Capacitaciones y certificaciones)': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla ESTADOCERTIFICADO. Dependencia: Se habilita si “¿Tiene capacitaciones y certificaciones?” es “SI”.',
		'Fecha de certificación': 'Valores permitidos: Debe ser anterior o igual a la fecha del sistema. Dependencia: Se habilita si “Estado” es “Certificado”.',
		'Duración en horas': 'Valores permitidos: Mayores a 0. Dependencia: Se habilita si “¿Tiene capacitaciones y certificaciones?” es “SI”.',
		'Agregar idioma': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla IDIOMA.',
		'Nivel idioma': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla NIVELIDIOMA.',
		'Tipo': 'Debe corresponder a un valor activo del catálogo del sistema de la tabla TIPOCONOCIMIENTOS.',
		'Herramientas': 'Mínimo 4 caracteres. Máximo 40 caracteres.',
		'Nivel': 'Valores permitidos: 1,2,3,4,5',
	} as Record<string, string>,
	fileName: 'plantilla_candidatos.xlsx',
	sheetName: 'Candidatos',
};

	export const vacantesCargue = {
		Headers: [
			'Tipo documento empresa',
			'Número documento de la empresa',
			'Nombre de la vacante',
			'Persona que solicita el cargo',
			'Teléfono de contacto',
			'Extensión de contacto',
			'Tipo de cargo de contacto',
			'Correo electrónico de contacto',
			'Solicitud de excepción de publicación por parte del empleador',
			'Cargos equivalentes a la vacante',
			'Descripción',
			'Perfil oculto de la vacante',
			'Nivel de estudio',
			'Graduado',
			'Formación o título requerido',
			'Departamento',
			'Municipio',
			'Localidad',
			'¿Requiere experiencia relacionada?',
			'¿Requiere capacitación específica?',
			'Modalidad de trabajo',
			'Descripción de la capacitación específica',
			'Vía principal',
			'Número 1',
			'Letra 1',
			'BIS 1',
			'Letra 2',
			'Cardinalidad 1',
			'Número 2',
			'Letra 3',
			'Número 3',
			'Cardinalidad 2',
			'Tipo de complemento',
			'Complemento',
			'Dirección vacante',
			'Punto de atención',
			'Experiencia mínima requerida (en meses)',
			'Nombre o tipo de la experiencia 1',
			'Cantidad en esa experiencia 1 (en meses)',
			'Fecha límite de aplicación',
			'Tipo de Contrato',
			'Área de conocimiento',
			'Jornada laboral',
			'Esta vacante debe ser confidencial',
			'Se requiere trabajo suplementario',
			'Tipo de vacante',
			'Días laborales',
			'Horario de trabajo',
			'Número de puestos de trabajo',
			'¿Cúal es el salario disponible para esta vacante?',
			'¿Cuál sería la máxima compensación al candidato ideal ?',
			'Pagos adicionales al salario',
			'Empleo verde',
			'Descripción ocupación de la vacante',
			'Persona en habitabilidad en calle',
			'Persona cuidadora',
			'Persona en proceso de reincorporación, reintegración y/o desmovilización',
			'Discapacidad (discapacidad física, discapacidad auditiva, discapacidad visual, sordoceguera, discapacidad intelectual, discapacidad psicosocial - mental, discapacidad múltiple)',
			'Grupo Étnico (Afrocolombiano, Comunidad Negra, Raizal, Palenquero, Indígena, Rrom/Gitano)',
			'Joven mayor de 18 años que está o estuvo en protección del ICBF',
			'Vendedor informal en reconversión laboral',
			'Joven del sistema de responsabilidad penal adolescente',
			'Persona migrante',
			'Mujer',
			'Persona joven (18 a 28 años)',
			'Persona mayor de 50 años',
			'Población postpenitenciaria - privada de la libertad al menos 3 meses',
			'Reciclador de oficio en reconversión laboral',
			'Persona en procesos de reintegración',
			'Retornado (persona que ha vivido en el extranjero y regresó al país)',
			'Persona que pertenece al Sisbén (A,B,C)',
			'Persona que realiza actividades sexuales pagas',
			'Persona trans',
			'Víctima del conflicto armado',
			'Persona víctima de trata de personas',
			'Víctima de violencia basada en género (VVG)',
			'Grupo étnico aceptado',
			'Discapacidad aceptada'
		],
		CamposObligatorios: [
			'Tipo documento empresa',
			'Número documento de la empresa',
			'Nombre de la vacante',
			'Persona que solicita el cargo',
			'Correo electrónico de contacto',
			'Nivel de estudio',
			'Departamento',
			'Municipio',
			'¿Requiere experiencia relacionada?',
			'Modalidad de trabajo',
			'Tipo de Contrato',
			'Jornada laboral',
			'Número de puestos de trabajo',
			'¿Cúal es el salario disponible para esta vacante?'
		],
		fileName: 'plantilla_vacantes.xlsx',
		sheetName: 'Vacantes'
	};
